import { SCHEMA_TYPE } from '@glass/shared/modules/jsonLd/constants/common';

export const BREADCRUMB_ITEM_TYPE = `${SCHEMA_TYPE}/BreadcrumbList`;
export const LIST_ITEM_TYPE = `${SCHEMA_TYPE}/ListItem`;
